import { profileKey } from '@staffedupusa/shared-components';
import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import {
  errorMessage,
  updateJobStatusCouponRoute,
} from '@features/profile';
import axiosInstance from '@server/axiosInstance';
import { jobPostingsKey } from '@features/jobPostings';

type UseUpdateJobCouponProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useUpdateJobCoupon = ({
  setErrorText = () => {},
}: UseUpdateJobCouponProps) => {

  const client = useQueryClient();

  const { mutate: updateJobStatus, isLoading: isUpdatingJobStatus } = useMutation({
    mutationFn: () =>
      axiosInstance
        .post(updateJobStatusCouponRoute)
        .then((res) => res.data),
    onSuccess: (data) => {
      if (data.status !== 200) {
        setErrorText(data.message);
      } else {
        setErrorText('');
        client.invalidateQueries([profileKey]);
        client.invalidateQueries([jobPostingsKey]);
      }
    },
    onError: () => setErrorText(errorMessage),
  });

  return {
    updateJobStatus,
    isUpdatingJobStatus,
  };
};
